export const DEFAULT_COLORS = {
  brand900: '#0e131f',
  brand700: '#333d4f',
  brand500: '#666e80',
  brand400: '#858a94',
  brand100: '#f1f5f9',
  blue: '#1e3a5f',
  green: '#1f7a5c',
  orange: '#c7411c'
};

export const PHASE_COLORS = {
  foundation: DEFAULT_COLORS.blue,
  sources: DEFAULT_COLORS.blue,
  external: DEFAULT_COLORS.blue,
  input: DEFAULT_COLORS.blue,
  intake: DEFAULT_COLORS.brand900,
  extension: DEFAULT_COLORS.brand900,
  grounding: DEFAULT_COLORS.brand700,
  logic: DEFAULT_COLORS.brand700,
  transport: DEFAULT_COLORS.brand700,
  control: DEFAULT_COLORS.brand500,
  safety: DEFAULT_COLORS.brand500,
  execution: DEFAULT_COLORS.green,
  result: DEFAULT_COLORS.green,
  billing: DEFAULT_COLORS.orange,
  secure: DEFAULT_COLORS.orange
};

export const MOBILE_LAYOUT_BREAKPOINT = 640;
export const NODE_WIDTH = 180;
export const NODE_HEIGHT = 80;
